import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Product } from "./Product";

@Entity({many: "entries"})
export class Entry {

	@Field()
	public id: ID;

	@Field()
	public displayName?: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate?: string;

	@Field({entity: Product})
	public product: Product;

	@Field()
	public enrollCount?: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Entry.ts